module.exports = __webpack_public_path__ + "6b6c0b38f96890958bb947000bbf0c5f.pdf";